import { render, staticRenderFns } from "./TipoEntradaNuevoEditar.vue?vue&type=template&id=7857b3d5&"
import script from "./TipoEntradaNuevoEditar.vue?vue&type=script&lang=js&"
export * from "./TipoEntradaNuevoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports